// German for the portfolio board ('#clients'). Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  // where a move's route lands (PAGE_LABEL)
  'the dashboard': 'das Dashboard',
  'the clients': 'die Kunden',
  'the gate': 'das Gate',
  'the documents': 'die Dokumente',
  'the register': 'das Register',
  'the agent queue': 'die Agenten-Warteschlange',
  'the proposals': 'die Vorschläge',
  'contracting': 'Vertrag',
  'acceptance': 'Abnahme',
  'the client portal': 'das Kundenportal',
  'admin': 'Admin',
  'the page': 'die Seite',
  'Open {page} →': '{page} öffnen →',
  'The timeline →': 'Die Zeitachse →',
  'Open the client →': 'Kunde öffnen →',
  'The brief →': 'Das Briefing →',

  'That row is not on the board under the current filter — the cell counts the whole register.': 'Diese Zeile ist unter dem aktuellen Filter nicht auf dem Board — die Zelle zählt das ganze Register.',
  'Name is required': 'Name ist erforderlich',
  '{name} added': '{name} hinzugefügt',
  'Client archived — it keeps its history and leaves the active list': 'Kunde archiviert — er behält seine Historie und verlässt die aktive Liste',
  '{label} deleted — {cascade} went with it': '{label} gelöscht — {cascade} mit entfernt',
  'nothing else': 'nichts weiter',
  'reading…': 'wird gelesen…',
  'roll-up did not answer': 'die Zusammenfassung hat nicht geantwortet',
  '“{query}”': '«{query}»',
  'status {status}': 'Status {status}',
  'under': 'unter',

  'Clients': 'Kunden',
  'on file': 'erfasst',
  'engaged': 'mit Auftrag',
  'board read at {date}': 'Board gelesen am {date}',
  'reading the register…': 'Register wird gelesen…',
  'the register did not answer': 'das Register hat nicht geantwortet',
  'New client': 'Neuer Kunde',
  'ENGAGED': 'BEAUFTRAGT',
  'QUEUED': 'ANSTEHEND',
  'BALL': 'BALL',
  'QUIET': 'STILL',
  'NEW': 'NEU',
  'All': 'Alle',
  'active': 'aktiv',
  'dormant': 'ruhend',
  'archived': 'archiviert',
  'Search name, short name, sector…': 'Name, Kurzname, Branche suchen…',
  'The gate tallies': 'Die Gate-Zählungen',

  'The board did not answer': 'Das Board hat nicht geantwortet',
  '{endpoint} answered: “{error}”. The client register itself is fine — what failed is the roll-up that ranks it.': '{endpoint} antwortete: «{error}». Das Kundenregister selbst ist in Ordnung — fehlgeschlagen ist die Zusammenfassung, die es ordnet.',
  'no response': 'keine Antwort',
  'Show the plain list instead': 'Stattdessen die einfache Liste zeigen',
  'The plain list': 'Die einfache Liste',
  '{n} client': '{n} Kunde',
  '{n} clients': '{n} Kunden',
  'Names and identities only — no ranking, no gate tallies, no silence. This is the degraded mode.': 'Nur Namen und Kennungen — keine Rangfolge, keine Gate-Zählungen, keine Stille. Das ist der eingeschränkte Modus.',
  'no sector on the record': 'keine Branche im Datensatz',
  'Open →': 'Öffnen →',
  'Archive — keeps every engagement, contact and document; the client leaves the active list': 'Archivieren — behält jeden Auftrag, Kontakt und jedes Dokument; der Kunde verlässt die aktive Liste',
  'Archive': 'Archivieren',
  'Delete {name} — for a row that should never have existed': '{name} löschen — für eine Zeile, die es nie hätte geben sollen',
  'Delete': 'Löschen',
  'No clients yet': 'Noch keine Kunden',
  'A client is the root of everything: engagements hang off it, and the document library belongs to it. Add the first one, then create an engagement against it.': 'Ein Kunde ist die Wurzel von allem: Aufträge hängen an ihm, und die Dokumentbibliothek gehört ihm. Legen Sie den ersten an und erstellen Sie dann einen Auftrag dazu.',
  'Nothing matches {what}': 'Nichts passt zu {what}',
  '{n} client is on file. The filter, not the register, is empty.': '{n} Kunde ist erfasst. Der Filter ist leer, nicht das Register.',
  '{n} clients are on file. The filter, not the register, is empty.': '{n} Kunden sind erfasst. Der Filter ist leer, nicht das Register.',
  'Clear the filter': 'Filter zurücksetzen',

  'Needs a move': 'Braucht einen Zug',
  '{n} move': '{n} Zug',
  '{n} moves': '{n} Züge',
  'Ranked by the rule that fired, not by name. The rule and its wording are the client page’s own — this board calls the same code.': 'Geordnet nach der ausgelösten Regel, nicht nach Name. Regel und Wortlaut gehören der Kundenseite — dieses Board ruft denselben Code auf.',
  'Nothing queued': 'Nichts anstehend',
  'No rule fired. A gate tally and a silence are not rules — read them here. Quiet is {days} days or more with nothing recorded.': 'Keine Regel ausgelöst. Eine Gate-Zählung und eine Stille sind keine Regeln — lesen Sie sie hier. Still heisst {days} Tage oder mehr ohne Eintrag.',
  'Not engaged': 'Ohne Auftrag',
  '{n} new item': '{n} neues Element',
  '{n} new items': '{n} neue Elemente',
  'Hide these rows': 'Diese Zeilen ausblenden',
  'Show these rows': 'Diese Zeilen einblenden',
  'No live engagement, so no gate and no queue beyond “create one”.': 'Kein laufender Auftrag, also kein Gate und keine Warteschlange ausser «einen erstellen».',
  'hide ▴': 'ausblenden ▴',
  'show ▾': 'einblenden ▾',
  'NEW counts from your last visit; where a client has never been opened, from {days} days back.': 'NEU zählt ab Ihrem letzten Besuch; wo ein Kunde nie geöffnet wurde, ab {days} Tagen zurück.',

  'Name, short name and sector are what the list scans. Legal name and address are what the SOW prints — the record surface takes them, and the brief will show {dash} until it does.': 'Name, Kurzname und Branche sind, was die Liste durchsucht. Rechtlicher Name und Adresse sind, was die Leistungsbeschreibung (SOW) druckt — der Datensatz nimmt sie auf, und das Briefing zeigt {dash}, bis er es tut.',
  'Name': 'Name',
  'Short name': 'Kurzname',
  'Sector': 'Branche',
  'Notes': 'Notizen',
  'The short name seeds derived engagement codes (e.g. {example}).': 'Der Kurzname bildet die Grundlage abgeleiteter Auftragscodes (z. B. {example}).',
  'Cancel': 'Abbrechen',
  'Create client': 'Kunde erstellen',

  'Archive client': 'Kunde archivieren',
  '{label} cannot be deleted': '{label} kann nicht gelöscht werden',
  'Delete {label}': '{label} löschen',
  'client': 'Kunde',
  'Archive instead': 'Stattdessen archivieren',
  'Deleting…': 'Wird gelöscht…',
  'Delete permanently': 'Endgültig löschen',
  'Archive “{label}”? Engagements and history are preserved — the client simply drops out of the active list. Nothing is removed, and you can bring it back by setting the status to active.': '«{label}» archivieren? Aufträge und Historie bleiben erhalten — der Kunde fällt lediglich aus der aktiven Liste. Nichts wird entfernt, und Sie können ihn zurückholen, indem Sie den Status auf aktiv setzen.',
  'Delete “{label}” outright? This is for a client that should never have existed — a real one that has finished gets archived instead.': '«{label}» endgültig löschen? Das ist für einen Kunden, den es nie hätte geben sollen — ein echter, abgeschlossener wird stattdessen archiviert.',
  '{count} {what} go with it': '{count} {what} werden mit entfernt',
  'Nothing else hangs off this client.': 'Nichts weiter hängt an diesem Kunden.',
  'Including {codes} with every requirement and run inside them — and the client’s document library, stored files included.': 'Einschliesslich {codes} mit allen Anforderungen und Läufen darin — und der Dokumentbibliothek des Kunden, gespeicherte Dateien inbegriffen.',
  'Immediate and irreversible. The audit log keeps the record.': 'Sofort und unwiderruflich. Der Prüfpfad behält den Eintrag.',

  // row parts
  'nothing on the client record': 'nichts im Kundendatensatz',
  'Qualify': 'Qualifizierung',
  'Discovery': 'Discovery',
  'Design': 'Konzeption',
  'Contracting': 'Vertrag',
  'Mobilise': 'Mobilisierung',
  'Implement': 'Umsetzung',
  'Acceptance': 'Abnahme',
  'Handover': 'Übergabe',
  'Close (phase)': 'Abschluss',
  '{gate} tally unknown': '{gate} Zählung unbekannt',
  '{gate} {met} of {total} automatic': '{gate} {met} von {total} automatisch',
  '+{n} archived': '+{n} archiviert',
  'Ball': 'Ball',
  'THEM': 'BEI IHNEN',
  'US': 'BEI UNS',
  '{ref} open {days} d': '{ref} offen seit {days} T',
  'no open commitment': 'keine offene Zusage',
  'Last contact': 'Letzter Kontakt',
  'never': 'nie',
  'd': 'T',
  '{n} more move on the brief': '{n} weiterer Zug im Briefing',
  '{n} more moves on the brief': '{n} weitere Züge im Briefing',
  '{n} more on the brief': '{n} weitere im Briefing',
  'Open the gate →': 'Gate öffnen →',
  'More for {name}': 'Mehr zu {name}',
  'Archive — keeps the history': 'Archivieren — behält die Historie',
  'Delete {name}…': '{name} löschen…',
  '{n} document': '{n} Dokument',
  '{n} documents': '{n} Dokumente',
  '{n} contact': '{n} Kontakt',
  '{n} contacts': '{n} Kontakte',
  '{n} archived engagement': '{n} archivierter Auftrag',
  '{n} archived engagements': '{n} archivierte Aufträge',
  '{what} · last contact {date}': '{what} · letzter Kontakt {date}',
  'nothing on the record at all': 'gar nichts im Datensatz',
  'new': 'neu',
  'reading the board…': 'Board wird gelesen…',
}, 'ClientsPage');
